import { render, staticRenderFns } from "./switching.vue?vue&type=template&id=fcd705ce&scoped=true&"
import script from "./switching.vue?vue&type=script&lang=js&"
export * from "./switching.vue?vue&type=script&lang=js&"
import style0 from "./switching.vue?vue&type=style&index=0&id=fcd705ce&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd705ce",
  null
  
)

export default component.exports